import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PathName } from 'appConstants';
import {
  ekiCoinIcon, 
  eki20Icon,
  eki50Icon,
  eki100Icon,
  eki250Icon,
  eki500Icon, 
} from 'assets/images';
import { useSelector } from 'react-redux';
import { profileSelectors } from 'store/profile/selectors';
import styles from './styles.module.scss';

interface IEKISectionProps {
  isAuthenticated: boolean;
}

const ekiLevels = [
  { eki: '20 EKI', roleKey: 'sapphire', img: eki20Icon },
  { eki: '50 EKI', roleKey: 'emerald', img: eki50Icon },
  { eki: '100 EKI', roleKey: 'ruby', img: eki100Icon },
  { eki: '250 EKI', roleKey: 'diamond', img: eki250Icon },
  { eki: '500 EKI', roleKey: 'blackDiamond', img: eki500Icon },
];

const whyFeatureKeys = ['capitalization', 'contribution', 'strategic'] as const;
const buttonKeys = ['superCase', 'increase', 'growth'] as const;

export const EKISection = ({ isAuthenticated }: IEKISectionProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation('eclipseDrive');
  const { referralCode } = useSelector(profileSelectors.getState);

  return (
    <div className={styles.section}>
      <div className={styles.section_content}>
        <h2 className={styles.section_title}>{t('eki.title')}</h2>
        <p className={styles.section_description}>
          {t('eki.description')}
        </p>

        <div className={styles.what_is_eki}>
          <div className={styles.info_card}>
            <h2 className={styles.card_title}>{t('eki.whatIsTitle')}</h2>
            <p className={styles.card_text}>
              {t('eki.whatIsText1')}
            </p>
            <p className={styles.card_text}>
              {t('eki.whatIsText2')}
            </p>
          </div>
          <img
            src={ekiCoinIcon}
            alt="EKI Coin"
            className={styles.eki_coin}
          />
        </div>

        <div className={styles.why_eki}>
          <div className={styles.eki_content_wrapper}>
            <div className={styles.left_column}>
              <h2 className={styles.section_subtitle}>{t('eki.whyTitle')}</h2>
              <ul className={styles.features_list}>
                {whyFeatureKeys.map((key) => (
                  <li
                    key={key}
                    className={styles.feature}
                  >
                    {t(`eki.whyFeatures.${key}`)}
                  </li>
                ))}
              </ul>
            </div>

            <div className={styles.eki_levels_table}>
              {ekiLevels.map(({ eki, roleKey }) => (
                <div
                  key={roleKey}
                  className={styles.table_row}
                >
                  <span className={styles.table_level}>{eki}</span>
                  <span className={styles.table_role}>{t(`eki.levels.${roleKey}`)}</span>
                </div>
              ))}
            </div>

            <div className={styles.ekiLevelsCases}>
              {ekiLevels.map(({ img }) => (
                <img
                  src={img}
                  alt="EKI Level"
                  className={styles.eki_image}
                />
              ))}
            </div>

            <div className={styles.buttons_row}>
              {buttonKeys.map((key) => (
                <span
                  key={key}
                  className={styles.eki_button}
                >
                  {t(`eki.buttons.${key}`)}
                </span>
              ))}
            </div>
          </div>
        </div>
        {!isAuthenticated && (
          <button
            type="button"
            className={styles.take_part_button}
            onClick={() => navigate(`${PathName.Registration}/?ref=${referralCode}`)}
          >
            {t('eki.cta')}
          </button>
        )}
      </div>
    </div>
  );
};
